import React from 'react';

const Logo = ({ variant = 'light', className = '' }) => {
  const isLight = variant === 'light';
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Icon/Symbol */}
      <div className="relative">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
          isLight ? 'bg-gradient-to-br from-teal-500 to-emerald-500' : 'bg-gradient-to-br from-teal-400 to-emerald-400'
        }`}>
          <span className="text-white font-bold text-xl">A</span>
        </div>
        {/* Accent dot */}
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full border-2 border-slate-900"></div>
      </div>
      
      {/* Text */}
      <div className="flex flex-col leading-none">
        <span className={`text-xs font-medium tracking-wider ${
          isLight ? 'text-slate-400' : 'text-slate-500'
        }`}>
          WITH
        </span>
        <span className={`text-2xl font-bold ${
          isLight ? 'text-white' : 'text-slate-900'
        }`}>
          Anshul
        </span>
      </div>
    </div>
  );
};

export default Logo;
